import { UserDetailsFormData } from './data/UserDetailsFormData';
import { UserDetailsFormState } from './state/UserDetailsFormState';

export class UserDetailsForm {
    data: UserDetailsFormData = new UserDetailsFormData();
    state: UserDetailsFormState = new UserDetailsFormState();
    doValidation: boolean = false;
}
